
import React, {  } from 'react';
import PageBox from '../../components/PageBox';
import AboutMenu from '../../components/AboutMenu';
import AboutTitle from '../../components/AboutTitle';
import './index.less'

export default function App() {
  return (
    <>
      <PageBox useBanner={true}>
        <div className='aboutBanner'></div>
        <AboutMenu active={'3'} />
        <AboutTitle name={'新闻动态'} english={'NEWS'}  />
        <div className='newsCon'>
          <h3 className='title'>荣获用友邀请，深耕香港生態建設</h3>
          <div className='time'>发布时间：2026-08-27</div>
          <div className='newsCon-con'>
            <p>近日，我司荣幸收到用友全球生态合作本部与用友香港的邀请，参与「用友生态伙伴香港行」系列走访交流活动，与多家独立软件开发商（ISV）、系统集成伙伴一道，深度走访联通国际、华为云、阿里云、新华三香港、香港宽频、凤凰卫视等头部生态企业。</p>
            <p><a href='https://mp.weixin.qq.com/s/78Y1G_i8dNrsh-SUSyRBmw' target='_blank' >https://mp.weixin.qq.com/s/78Y1G_i8dNrsh-SUSyRBmw </a> </p>
            <div style={{height:'80px'}}></div>
          </div>
        </div>
      </PageBox>
    </>
  );
}